/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.6.3.0 (NJsonSchema v11.5.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class AppContextsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        get: (
        ): string => {
            let clientRequestUrl = '/api/v1/appcontexts';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get application context
     * @return OK
     */
    get(): Promise<AppContext> {
        const clientRequestUrl = this.baseUrl + this.routes.get(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<AppContext>(_response, false, []);
        });
    }
}

export class HealthClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        get: (
        ): string => {
            let clientRequestUrl = '/api/v1/health';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getDetailed: (
        ): string => {
            let clientRequestUrl = '/api/v1/health/details';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getLiveness: (
        ): string => {
            let clientRequestUrl = '/api/v1/health/liveness';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getReadiness: (
        ): string => {
            let clientRequestUrl = '/api/v1/health/readiness';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get Health status
     * @return OK
     */
    get(): Promise<HealthStatusReport> {
        const clientRequestUrl = this.baseUrl + this.routes.get(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<HealthStatusReport>(_response, false, []);
        });
    }

    /**
     * Get Health detailed status
     * @return OK
     */
    getDetailed(): Promise<HealthStatusReportDetailed> {
        const clientRequestUrl = this.baseUrl + this.routes.getDetailed(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<HealthStatusReportDetailed>(_response, false, ['executionDateTimeUtc']);
        });
    }

    /**
     * Get liveness
     * @return OK
     */
    getLiveness(): Promise<HealthStatusReport> {
        const clientRequestUrl = this.baseUrl + this.routes.getLiveness(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<HealthStatusReport>(_response, false, []);
        });
    }

    /**
     * Get readiness
     * @return OK
     */
    getReadiness(): Promise<HealthStatusReport> {
        const clientRequestUrl = this.baseUrl + this.routes.getReadiness(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<HealthStatusReport>(_response, false, []);
        });
    }
}

export class ThirdPartiesClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getAccess: (
			icIds?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/thirdparties/access?';
            if (icIds === null) {
                throw new Error('The parameter "icIds" cannot be null.');
            } else if (icIds !== undefined) {
                clientRequestUrl += 'icIds=' + encodeURIComponent('' + icIds) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getHistory: (
        ): string => {
            let clientRequestUrl = '/api/v1/thirdparties/do-get-history';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getAllVendors: (
			includeInactive?: boolean | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/thirdparties/vendors?';
            if (includeInactive === null) {
                throw new Error('The parameter "includeInactive" cannot be null.');
            } else if (includeInactive !== undefined) {
                clientRequestUrl += 'includeInactive=' + encodeURIComponent('' + includeInactive) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getPendingRequests: (
        ): string => {
            let clientRequestUrl = '/api/v1/thirdparties/requests';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        requestOpenAccess: (
			icId: string,
			vendorId: number,
			userId?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/thirdparties/access/{icId}/request/{vendorId}?';
            if (icId === undefined || icId === null) {
                throw new Error('The parameter "icId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent('' + icId));
            if (vendorId === undefined || vendorId === null) {
                throw new Error('The parameter "vendorId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{vendorId}', encodeURIComponent('' + vendorId));
            if (userId === null) {
                throw new Error('The parameter "userId" cannot be null.');
            } else if (userId !== undefined) {
                clientRequestUrl += 'userId=' + encodeURIComponent('' + userId) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        requestRemoveAccess: (
			icId: string,
			vendorId: number,
			userId?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/thirdparties/access/{icId}/request/{vendorId}?';
            if (icId === undefined || icId === null) {
                throw new Error('The parameter "icId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent('' + icId));
            if (vendorId === undefined || vendorId === null) {
                throw new Error('The parameter "vendorId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{vendorId}', encodeURIComponent('' + vendorId));
            if (userId === null) {
                throw new Error('The parameter "userId" cannot be null.');
            } else if (userId !== undefined) {
                clientRequestUrl += 'userId=' + encodeURIComponent('' + userId) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        approveRequest: (
			icId: string,
			vendorId: number,
        ): string => {
            let clientRequestUrl = '/api/v1/thirdparties/access/{icId}/request/{vendorId}/approve';
            if (icId === undefined || icId === null) {
                throw new Error('The parameter "icId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent('' + icId));
            if (vendorId === undefined || vendorId === null) {
                throw new Error('The parameter "vendorId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{vendorId}', encodeURIComponent('' + vendorId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        rejectRequest: (
			icId: string,
			vendorId: number,
        ): string => {
            let clientRequestUrl = '/api/v1/thirdparties/access/{icId}/request/{vendorId}/reject';
            if (icId === undefined || icId === null) {
                throw new Error('The parameter "icId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent('' + icId));
            if (vendorId === undefined || vendorId === null) {
                throw new Error('The parameter "vendorId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{vendorId}', encodeURIComponent('' + vendorId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        openAccess: (
			icId: string,
			vendorId: number,
			userId?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/thirdparties/access/{icId}/{vendorId}?';
            if (icId === undefined || icId === null) {
                throw new Error('The parameter "icId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent('' + icId));
            if (vendorId === undefined || vendorId === null) {
                throw new Error('The parameter "vendorId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{vendorId}', encodeURIComponent('' + vendorId));
            if (userId === null) {
                throw new Error('The parameter "userId" cannot be null.');
            } else if (userId !== undefined) {
                clientRequestUrl += 'userId=' + encodeURIComponent('' + userId) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        removeAccess: (
			icId: string,
			vendorId: number,
			userId?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/thirdparties/access/{icId}/{vendorId}?';
            if (icId === undefined || icId === null) {
                throw new Error('The parameter "icId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent('' + icId));
            if (vendorId === undefined || vendorId === null) {
                throw new Error('The parameter "vendorId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{vendorId}', encodeURIComponent('' + vendorId));
            if (userId === null) {
                throw new Error('The parameter "userId" cannot be null.');
            } else if (userId !== undefined) {
                clientRequestUrl += 'userId=' + encodeURIComponent('' + userId) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        updateVendorUserInfo: (
			icId: string,
			vendorId: number,
			userId?: string | undefined,
			companyId?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/thirdparties/access/{icId}/{vendorId}?';
            if (icId === undefined || icId === null) {
                throw new Error('The parameter "icId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent('' + icId));
            if (vendorId === undefined || vendorId === null) {
                throw new Error('The parameter "vendorId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{vendorId}', encodeURIComponent('' + vendorId));
            if (userId === null) {
                throw new Error('The parameter "userId" cannot be null.');
            } else if (userId !== undefined) {
                clientRequestUrl += 'userId=' + encodeURIComponent('' + userId) + '&';
            }
            if (companyId === null) {
                throw new Error('The parameter "companyId" cannot be null.');
            } else if (companyId !== undefined) {
                clientRequestUrl += 'companyId=' + encodeURIComponent('' + companyId) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        removeAllAccesses: (
        ): string => {
            let clientRequestUrl = '/api/v1/thirdparties/accesses';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getUsersIcId: (
			vendorId: number,
			vendorUserIds?: string[] | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/thirdparties/vendors/{vendorId}?';
            if (vendorId === undefined || vendorId === null) {
                throw new Error('The parameter "vendorId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{vendorId}', encodeURIComponent('' + vendorId));
            if (vendorUserIds === null) {
                throw new Error('The parameter "vendorUserIds" cannot be null.');
            } else if (vendorUserIds !== undefined) {
                vendorUserIds && vendorUserIds.forEach(item => { clientRequestUrl += 'vendorUserIds=' + encodeURIComponent('' + item) + '&'; });
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get vendor access by IcId list
     * @param icIds (optional) list of user icIds split with comma separator
     * @return OK
     */
    getAccess(icIds?: string | undefined): Promise<{ [key: string]: ThirdPartiesAccess[]; }> {
        const clientRequestUrl = this.baseUrl + this.routes.getAccess(
            icIds,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<{ [key: string]: ThirdPartiesAccess[]; }>(_response, false, ['openRequestedDate', 'openDate', 'openRejectedDate', 'closeRequestedDate', 'closeDate', 'closeRejectedDate']);
        });
    }

    /**
     * Get vendor access history by IcId list
     * @param body (optional) take, skip, icId
     * @return OK
     */
    getHistory(body?: SearchHistoryRequest | undefined): Promise<ThirdPartiesAccessPaginationResult> {
        const clientRequestUrl = this.baseUrl + this.routes.getHistory(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ThirdPartiesAccessPaginationResult>(_response, false, ['openRequestedDate', 'openDate', 'openRejectedDate', 'closeRequestedDate', 'closeDate', 'closeRejectedDate']);
        });
    }

    /**
     * Get All Vendors
     * @param includeInactive (optional) Include inactive
     * @return OK
     */
    getAllVendors(includeInactive?: boolean | undefined): Promise<GetAllVendorsResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getAllVendors(
            includeInactive,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetAllVendorsResponse>(_response, false, []);
        });
    }

    /**
     * Get pending requests
     * @return OK
     */
    getPendingRequests(): Promise<GetPendingRequestsResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getPendingRequests(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetPendingRequestsResponse>(_response, false, ['openRequestedDate', 'openDate', 'openRejectedDate', 'closeRequestedDate', 'closeDate', 'closeRejectedDate']);
        });
    }

    /**
     * Request open vendor access
     * @param icId user IC id
     * @param vendorId vendor id
     * @param userId (optional) vendor user id
     * @return OK
     */
    requestOpenAccess(icId: string, vendorId: number, userId?: string | undefined): Promise<ThirdPartiesAccess> {
        const clientRequestUrl = this.baseUrl + this.routes.requestOpenAccess(
            icId,
            vendorId,
            userId,
        );

        const options = {
            method: 'POST',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ThirdPartiesAccess>(_response, false, ['openRequestedDate', 'openDate', 'openRejectedDate', 'closeRequestedDate', 'closeDate', 'closeRejectedDate']);
        });
    }

    /**
     * Request remove vendor access
     * @param icId user IC id
     * @param vendorId vendor id
     * @param userId (optional) vendor user id
     * @return OK
     */
    requestRemoveAccess(icId: string, vendorId: number, userId?: string | undefined): Promise<ThirdPartiesAccess> {
        const clientRequestUrl = this.baseUrl + this.routes.requestRemoveAccess(
            icId,
            vendorId,
            userId,
        );

        const options = {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ThirdPartiesAccess>(_response, false, ['openRequestedDate', 'openDate', 'openRejectedDate', 'closeRequestedDate', 'closeDate', 'closeRejectedDate']);
        });
    }

    /**
     * Approve vendor access request
     * @param icId user IC id
     * @param vendorId vendor id
     * @return OK
     */
    approveRequest(icId: string, vendorId: number): Promise<ThirdPartiesAccess> {
        const clientRequestUrl = this.baseUrl + this.routes.approveRequest(
            icId,
            vendorId,
        );

        const options = {
            method: 'PUT',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ThirdPartiesAccess>(_response, false, ['openRequestedDate', 'openDate', 'openRejectedDate', 'closeRequestedDate', 'closeDate', 'closeRejectedDate']);
        });
    }

    /**
     * Reject vendor access request
     * @param icId user IC id
     * @param vendorId vendor id
     * @return OK
     */
    rejectRequest(icId: string, vendorId: number): Promise<ThirdPartiesAccess> {
        const clientRequestUrl = this.baseUrl + this.routes.rejectRequest(
            icId,
            vendorId,
        );

        const options = {
            method: 'PUT',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ThirdPartiesAccess>(_response, false, ['openRequestedDate', 'openDate', 'openRejectedDate', 'closeRequestedDate', 'closeDate', 'closeRejectedDate']);
        });
    }

    /**
     * Open vendor access
     * @param icId user IC id
     * @param vendorId vendor id
     * @param userId (optional) vendor user id
     * @return OK
     */
    openAccess(icId: string, vendorId: number, userId?: string | undefined): Promise<ThirdPartiesAccess> {
        const clientRequestUrl = this.baseUrl + this.routes.openAccess(
            icId,
            vendorId,
            userId,
        );

        const options = {
            method: 'POST',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ThirdPartiesAccess>(_response, false, ['openRequestedDate', 'openDate', 'openRejectedDate', 'closeRequestedDate', 'closeDate', 'closeRejectedDate']);
        });
    }

    /**
     * Remove vendor access
     * @param icId user IC id
     * @param vendorId vendor id
     * @param userId (optional) vendor user id
     * @return OK
     */
    removeAccess(icId: string, vendorId: number, userId?: string | undefined): Promise<ThirdPartiesAccess> {
        const clientRequestUrl = this.baseUrl + this.routes.removeAccess(
            icId,
            vendorId,
            userId,
        );

        const options = {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ThirdPartiesAccess>(_response, false, ['openRequestedDate', 'openDate', 'openRejectedDate', 'closeRequestedDate', 'closeDate', 'closeRejectedDate']);
        });
    }

    /**
     * Update Third party User info
     * @param icId user IC id
     * @param vendorId vendor id
     * @param userId (optional) vendor user id
     * @param companyId (optional) vendor companyId id
     * @return OK
     */
    updateVendorUserInfo(icId: string, vendorId: number, userId?: string | undefined, companyId?: string | undefined): Promise<ThirdPartiesAccess> {
        const clientRequestUrl = this.baseUrl + this.routes.updateVendorUserInfo(
            icId,
            vendorId,
            userId,
            companyId,
        );

        const options = {
            method: 'PUT',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ThirdPartiesAccess>(_response, false, ['openRequestedDate', 'openDate', 'openRejectedDate', 'closeRequestedDate', 'closeDate', 'closeRejectedDate']);
        });
    }

    /**
     * Remove all vendor access
     * @param body (optional) 
     * @return OK
     */
    removeAllAccesses(body?: RemoveAllAccessRequest | undefined): Promise<RemoveAllAccessesResult> {
        const clientRequestUrl = this.baseUrl + this.routes.removeAllAccesses(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<RemoveAllAccessesResult>(_response, false, []);
        });
    }

    /**
     * Get users icId from vendor id and vendor users id
     * @param vendorId vendor id
     * @param vendorUserIds (optional) vendors users id
     * @return OK
     */
    getUsersIcId(vendorId: number, vendorUserIds?: string[] | undefined): Promise<GetUsersIcIdResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getUsersIcId(
            vendorId,
            vendorUserIds,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetUsersIcIdResponse>(_response, false, []);
        });
    }
}

export class VendorsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        requestOpenAccess: (
			vendorId: number,
			icId: string,
			requestId?: number | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/vendors/{vendorId}/open/{icId}?';
            if (vendorId === undefined || vendorId === null) {
                throw new Error('The parameter "vendorId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{vendorId}', encodeURIComponent('' + vendorId));
            if (icId === undefined || icId === null) {
                throw new Error('The parameter "icId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent('' + icId));
            if (requestId === null) {
                throw new Error('The parameter "requestId" cannot be null.');
            } else if (requestId !== undefined) {
                clientRequestUrl += 'requestId=' + encodeURIComponent('' + requestId) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        requestRemoveAccess: (
			vendorId: number,
			icId: string,
			userId?: string | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/vendors/{vendorId}/remove/{icId}?';
            if (vendorId === undefined || vendorId === null) {
                throw new Error('The parameter "vendorId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{vendorId}', encodeURIComponent('' + vendorId));
            if (icId === undefined || icId === null) {
                throw new Error('The parameter "icId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{icId}', encodeURIComponent('' + icId));
            if (userId === null) {
                throw new Error('The parameter "userId" cannot be null.');
            } else if (userId !== undefined) {
                clientRequestUrl += 'userId=' + encodeURIComponent('' + userId) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        openVendorAccesses: (
			vendorId: number,
        ): string => {
            let clientRequestUrl = '/api/v1/vendors/{vendorId}/open-accesses';
            if (vendorId === undefined || vendorId === null) {
                throw new Error('The parameter "vendorId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{vendorId}', encodeURIComponent('' + vendorId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        closeVendorAccesses: (
			vendorId: number,
        ): string => {
            let clientRequestUrl = '/api/v1/vendors/{vendorId}/close-accesses';
            if (vendorId === undefined || vendorId === null) {
                throw new Error('The parameter "vendorId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{vendorId}', encodeURIComponent('' + vendorId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        rejectAccessRequests: (
        ): string => {
            let clientRequestUrl = '/api/v1/vendors/reject-accesses';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        rejectAccessRequestsBySales: (
        ): string => {
            let clientRequestUrl = '/api/v1/vendors/sales-reject-accesses';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        createVendorRequestAccess: (
			vendorId: number,
        ): string => {
            let clientRequestUrl = '/api/v1/vendors/{vendorId}/request-access';
            if (vendorId === undefined || vendorId === null) {
                throw new Error('The parameter "vendorId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{vendorId}', encodeURIComponent('' + vendorId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getVendorUserGroups: (
			vendorId: number,
        ): string => {
            let clientRequestUrl = '/api/v1/vendors/{vendorId}/get-user-groups';
            if (vendorId === undefined || vendorId === null) {
                throw new Error('The parameter "vendorId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{vendorId}', encodeURIComponent('' + vendorId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        searchResearchAccessRequests: (
        ): string => {
            let clientRequestUrl = '/api/v1/vendors/do-get-requests';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getResearchAccessRequestById: (
			requestId: number,
        ): string => {
            let clientRequestUrl = '/api/v1/vendors/request/{requestId}';
            if (requestId === undefined || requestId === null) {
                throw new Error('The parameter "requestId" must be defined.');
            }
            clientRequestUrl = clientRequestUrl.replace('{requestId}', encodeURIComponent('' + requestId));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        editStep: (
        ): string => {
            let clientRequestUrl = '/api/v1/vendors/step';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        editSalesContact: (
        ): string => {
            let clientRequestUrl = '/api/v1/vendors/sales-contact';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getPendingSalesRequestsCount: (
        ): string => {
            let clientRequestUrl = '/api/v1/vendors/pending-sales-requests/count';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        sendPendingSalesRequestsNotifications: (
        ): string => {
            let clientRequestUrl = '/api/v1/vendors/send-pending-sales-requests';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        sendPendingSalesRequestsNotificationsReminder: (
        ): string => {
            let clientRequestUrl = '/api/v1/vendors/send-pending-sales-requests-reminders';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        synchronizeVendorRequests: (
        ): string => {
            let clientRequestUrl = '/api/v1/vendors/do-synchronize-requests';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Request open access
     * @param vendorId Vendor id
     * @param icId user IC id
     * @param requestId (optional) Request id
     * @param body (optional) request
     * @return OK
     */
    requestOpenAccess(vendorId: number, icId: string, requestId?: number | undefined, body?: OpenAccessRequest | undefined): Promise<OpenRemoveAccessResult> {
        const clientRequestUrl = this.baseUrl + this.routes.requestOpenAccess(
            vendorId,
            icId,
            requestId,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<OpenRemoveAccessResult>(_response, false, []);
        });
    }

    /**
     * Request remove access
     * @param vendorId Vendor id
     * @param icId user IC id
     * @param userId (optional) vendor user id
     * @return OK
     */
    requestRemoveAccess(vendorId: number, icId: string, userId?: string | undefined): Promise<OpenRemoveAccessResult> {
        const clientRequestUrl = this.baseUrl + this.routes.requestRemoveAccess(
            vendorId,
            icId,
            userId,
        );

        const options = {
            method: 'POST',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<OpenRemoveAccessResult>(_response, false, []);
        });
    }

    /**
     * Open multiple accesses
     * @param vendorId vendorId
     * @param body (optional) request
     * @return OK
     */
    openVendorAccesses(vendorId: number, body?: ManageVendorAccessesRequest | undefined): Promise<ManageAccessesResult> {
        const clientRequestUrl = this.baseUrl + this.routes.openVendorAccesses(
            vendorId,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ManageAccessesResult>(_response, false, []);
        });
    }

    /**
     * Close multiple accesses
     * @param vendorId vendorId
     * @param body (optional) request
     * @return OK
     */
    closeVendorAccesses(vendorId: number, body?: ManageVendorAccessesRequest | undefined): Promise<ManageAccessesResult> {
        const clientRequestUrl = this.baseUrl + this.routes.closeVendorAccesses(
            vendorId,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<ManageAccessesResult>(_response, false, []);
        });
    }

    /**
     * Reject access request and notify the user by email
     * @param body (optional) request
     * @return OK
     */
    rejectAccessRequests(body?: RejectAccessesRequest | undefined): Promise<RejectAccessRequestsResult> {
        const clientRequestUrl = this.baseUrl + this.routes.rejectAccessRequests(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<RejectAccessRequestsResult>(_response, false, []);
        });
    }

    /**
     * Reject access request for Sales and notify the user by email
     * @param body (optional) request
     * @return OK
     */
    rejectAccessRequestsBySales(body?: RejectAccessesBySalesRequest | undefined): Promise<RejectAccessRequestsResult> {
        const clientRequestUrl = this.baseUrl + this.routes.rejectAccessRequestsBySales(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<RejectAccessRequestsResult>(_response, false, []);
        });
    }

    /**
     * Create vendor access request
     * @param body (optional) 
     * @return OK
     */
    createVendorRequestAccess(vendorId: number, body?: VendorAccessRequest | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.createVendorRequestAccess(
            vendorId,
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, []);
        });
    }

    /**
     * Get Vendor User Groups by Ids
     * @return OK
     */
    getVendorUserGroups(vendorId: number): Promise<FactsetUserGroups> {
        const clientRequestUrl = this.baseUrl + this.routes.getVendorUserGroups(
            vendorId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<FactsetUserGroups>(_response, false, []);
        });
    }

    /**
     * Search Research access requests
     * @param body (optional) 
     * @return OK
     */
    searchResearchAccessRequests(body?: VendorRequestBody | undefined): Promise<LightVendorRequestPaginationResult> {
        const clientRequestUrl = this.baseUrl + this.routes.searchResearchAccessRequests(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<LightVendorRequestPaginationResult>(_response, false, ['requestedOn', 'lastNotifiedOn']);
        });
    }

    /**
     * Get Research access request by id
     * @return OK
     */
    getResearchAccessRequestById(requestId: number): Promise<VendorRequest> {
        const clientRequestUrl = this.baseUrl + this.routes.getResearchAccessRequestById(
            requestId,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<VendorRequest>(_response, false, ['requestedOn', 'lastNotifiedOn', 'creationDateUtc']);
        });
    }

    /**
     * Edit Vendor Request Step
     * @param body (optional) 
     * @return OK
     */
    editStep(body?: EditStepRequest | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.editStep(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, []);
        });
    }

    /**
     * Edit Sales Contact
     * @param body (optional) 
     * @return OK
     */
    editSalesContact(body?: EditSalesContactRequest | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.editSalesContact(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, []);
        });
    }

    /**
     * Get count of pending sales requests never notified before
     * @return OK
     */
    getPendingSalesRequestsCount(): Promise<PendingSalesRequestsCount> {
        const clientRequestUrl = this.baseUrl + this.routes.getPendingSalesRequestsCount(
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<PendingSalesRequestsCount>(_response, false, []);
        });
    }

    /**
     * Send emails for all pending sales requests never notified before
     * @return OK
     */
    sendPendingSalesRequestsNotifications(): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.sendPendingSalesRequestsNotifications(
        );

        const options = {
            method: 'POST',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, []);
        });
    }

    /**
     * Send reminder emails for requested pending sales requests
     * @param body (optional) 
     * @return OK
     */
    sendPendingSalesRequestsNotificationsReminder(body?: ReminderRequest | undefined): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.sendPendingSalesRequestsNotificationsReminder(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, []);
        });
    }

    /**
     * Synchronize vendors requests from vendor system
     * @return OK
     */
    synchronizeVendorRequests(): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.synchronizeVendorRequests(
        );

        const options = {
            method: 'POST',
            headers: {
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<void>(_response, false, []);
        });
    }
}

/** Access Request */
export interface AccessRequest {
    /** ContactId */
    contactId: string;
    /** Insight Profiles */
    insightProfiles?: InsightProfile[] | undefined;
}

/** App context */
export interface AppContext {
    /** Logged user */
    loggedUser?: LoggedUser | undefined;
    /** Environment */
    environment?: string | undefined;
}

export interface ErrorDto {
    code?: string | undefined;
    message?: string | undefined;
    target?: string | undefined;
    details?: ErrorDto[] | undefined;
}

export interface DetailedError extends ErrorDto {
    detailedMessage?: string | undefined;
    stackTrace?: string | undefined;
}

export interface EditSalesContactRequest {
    requestId: number;
    icId: string;
}

export interface EditStep {
    requestId: number;
    step: ValidationSteps;
    rejectReason?: string | undefined;
    openedAccesses?: string[] | undefined;
}

export interface EditStepRequest {
    requests?: EditStep[] | undefined;
}

/** FactsetUserGroups */
export interface FactsetUserGroups {
    /** Groups */
    groups?: UserGroups[] | undefined;
}

/** Get All Vendors Response */
export interface GetAllVendorsResponse {
    /** Vendors */
    vendors?: Vendor[] | undefined;
}

/** Get Pending Requests Response */
export interface GetPendingRequestsResponse {
    /** Vendors */
    pendingRequests?: ThirdPartiesAccess[] | undefined;
}

/** Get Users IcId Response */
export interface GetUsersIcIdResponse {
    /** Vendors Users */
    vendorsUsers?: VendorsUsers[] | undefined;
}

export interface HealthCheckReportEntryDetailed {
    name?: string | undefined;
    status: HealthStatus;
    type?: string | undefined;
    description?: string | undefined;
    tags?: string[] | undefined;
    data?: { [key: string]: any; } | undefined;
    problems?: Problem[] | undefined;
}

export enum HealthStatus {
    Unhealthy = "Unhealthy",
    Degraded = "Degraded",
    Healthy = "Healthy",
}

export interface HealthStatusReport {
    status: HealthStatus;
}

export interface HealthStatusReportDetailed {
    status: HealthStatus;
    executionDateTimeUtc: Date;
    apiCode?: string | undefined;
    checks?: HealthCheckReportEntryDetailed[] | undefined;
}

export enum InsightProfile {
    BasicAccess = "BasicAccess",
    IndexWatchAccess = "IndexWatchAccess",
    EtfScreenerAccess = "EtfScreenerAccess",
    EtfDirectoriesAccess = "EtfDirectoriesAccess",
    SalesAndTradingAccess = "SalesAndTradingAccess",
}

export enum InsightRequestAccessOrigin {
    Ic = "Ic",
    UnauthorizedWidget = "UnauthorizedWidget",
    PublicInsight = "PublicInsight",
    InfoRequestAccess = "InfoRequestAccess",
}

export interface LightVendorRequest {
    id: number;
    vendor?: string | undefined;
    vendorId: number;
    requestedOn?: Date | undefined;
    step: ValidationSteps;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    companyName?: string | undefined;
    salesContact?: string | undefined;
    salesContactGuid?: string | undefined;
    lastNotifiedOn?: Date | undefined;
    insightProfiles?: InsightProfile[] | undefined;
    requestOrigin?: InsightRequestAccessOrigin | undefined;
}

export interface LightVendorRequestPaginationResult {
    results?: LightVendorRequest[] | undefined;
    totalResults?: number | undefined;
    skip: number;
    take: number;
}

export interface LoggedUser {
    contactId: string;
    mail?: string | undefined;
    clientId: string;
    permissions?: string[] | undefined;
}

export interface ManageAccessResult {
    contactId: string;
    insightProfiles: InsightProfile[] | undefined;
    isSuccess: boolean;
}

/** Open/Close Accesses Result */
export interface ManageAccessesResult {
    /** Results */
    results?: ManageAccessResult[] | undefined;
}

/** Open/Close Vendor Accesses Request */
export interface ManageVendorAccessesRequest {
    /** Access Requests */
    accessRequests?: AccessRequest[] | undefined;
}

/** Open Access Request */
export interface OpenAccessRequest {
    /** Group Ids */
    groupIds?: string[] | undefined;
    /** Insight Profiles */
    insightProfiles?: InsightProfile[] | undefined;
}

/** Open or remove access result */
export interface OpenRemoveAccessResult {
    icId: string;
    vendorId: number;
    /** Action is success */
    isSuccess: boolean;
    /** Group Ids */
    groupIds?: string[] | undefined;
}

/** Pending Sales Requests Count */
export interface PendingSalesRequestsCount {
    /** Count */
    count: number;
}

export interface Problem {
    detail?: string | undefined;
}

export interface RejectAccessRequest {
    requestId: number;
    comment?: string | undefined;
    reason: RejectReasonType;
}

export interface RejectAccessRequestsResult {
    results?: RejectRequestResult[] | undefined;
}

/** Reject Accesses By Sales Request */
export interface RejectAccessesBySalesRequest {
    /** List of requestIds to reject */
    requestIds?: number[] | undefined;
}

/** Reject Accesses Request */
export interface RejectAccessesRequest {
    /** List of request ids to reject with the reason */
    requests?: RejectAccessRequest[] | undefined;
}

export enum RejectReasonType {
    IncorrectSales = "IncorrectSales",
    NoResponseFromSales = "NoResponseFromSales",
    RejectedBySales = "RejectedBySales",
    JournalistNotAuthorized = "JournalistNotAuthorized",
    PersonalEmail = "PersonalEmail",
    GroupMailbox = "GroupMailbox",
    Other = "Other",
}

export interface RejectRequestResult {
    requestId: number;
    isSuccess: boolean;
}

export interface ReminderRequest {
    requestIds: number[] | undefined;
}

export interface RemoveAllAccessRequest {
    icIds?: string[] | undefined;
    closingByIcId?: string | undefined;
}

export interface RemoveAllAccessesResult {
    factsetFailedToCloseIcIds?: string[] | undefined;
    reutersFailedToCloseIcIds?: string[] | undefined;
}

export interface SearchHistoryRequest {
    take: number;
    skip: number;
    icId: string;
}

export interface ThirdPartiesAccess {
    actions?: ThirdPartiesAccessAction[] | undefined;
    id: number;
    icId?: string | undefined;
    status: ThirdPartyStatus;
    thirdParty?: ThirdParty | undefined;
    openRequestedByIcId?: string | undefined;
    openRequestedBy?: string | undefined;
    openRequestedDate?: Date | undefined;
    openByIcId?: string | undefined;
    openBy?: string | undefined;
    openDate?: Date | undefined;
    openRejectedByIcId?: string | undefined;
    openRejectedBy?: string | undefined;
    openRejectedDate?: Date | undefined;
    closeRequestedByIcId?: string | undefined;
    closeRequestedBy?: string | undefined;
    closeRequestedDate?: Date | undefined;
    closeByIcId?: string | undefined;
    closeBy?: string | undefined;
    closeDate?: Date | undefined;
    closeRejectedByIcId?: string | undefined;
    closeRejectedBy?: string | undefined;
    closeRejectedDate?: Date | undefined;
}

export enum ThirdPartiesAccessAction {
    RequestOpen = "RequestOpen",
    Open = "Open",
    RejectOpen = "RejectOpen",
    RequestClose = "RequestClose",
    Close = "Close",
    RejectClose = "RejectClose",
    UpdateUserId = "UpdateUserId",
}

export interface ThirdPartiesAccessPaginationResult {
    results?: ThirdPartiesAccess[] | undefined;
    totalResults?: number | undefined;
    skip: number;
    take: number;
}

export interface ThirdParty {
    id: number;
    name?: string | undefined;
    userId?: string | undefined;
    companyId?: string | undefined;
}

export enum ThirdPartyStatus {
    None = "None",
    RequestOpenPending = "RequestOpenPending",
    Opened = "Opened",
    RequestClosePending = "RequestClosePending",
    Closed = "Closed",
}

export interface UserGroups {
    id?: string | undefined;
    name?: string | undefined;
}

export enum ValidationSteps {
    READY_TO_START = "READY_TO_START",
    WAITING_FOR_SALES_VALIDATION = "WAITING_FOR_SALES_VALIDATION",
    APPROVED_BY_SALES = "APPROVED_BY_SALES",
    REJECTED_BY_SALES = "REJECTED_BY_SALES",
    OPENED = "OPENED",
    REJECTED = "REJECTED",
    REQUESTED_BY_SALES = "REQUESTED_BY_SALES",
    INVALID_REQUEST = "INVALID_REQUEST",
    CANCELLED = "CANCELLED",
}

export interface Vendor {
    id: number;
    name?: string | undefined;
    rank: number;
}

/** Request Vendor Access Request */
export interface VendorAccessRequest {
    /** Company Name */
    companyName?: string | undefined;
    /** Contact Name */
    contactName?: string | undefined;
    /** Contact Email */
    contactEmail?: string | undefined;
    /** Job */
    job?: string | undefined;
    /** Location */
    location?: string | undefined;
    /** SourceUrl */
    sourceUrl?: string | undefined;
    /** Comment */
    comment?: string | undefined;
    /** Sales Contact */
    salesContact?: string | undefined;
    /** Sales Contact Id */
    salesContactId?: string | undefined;
    /** Vendor Profile Ids */
    vendorProfileIds?: string[] | undefined;
    /** Is Requested By Sales On Behalf */
    isRequestedBySalesOnBehalf: boolean;
}

export enum VendorAuditActionType {
    StartWorkflow = "StartWorkflow",
    ApproveBySales = "ApproveBySales",
    RejectBySales = "RejectBySales",
    Open = "Open",
    Reject = "Reject",
    SendReminders = "SendReminders",
    EditSales = "EditSales",
    Create = "Create",
    CreateBySales = "CreateBySales",
    Cancel = "Cancel",
}

export interface VendorAuditEntry {
    id: number;
    createdBy?: string | undefined;
    createdByName?: string | undefined;
    creationDateUtc: Date;
    salesGuid?: string | undefined;
    rejectReason?: string | undefined;
    isSyncFromIam: boolean;
    openedAccesses?: string[] | undefined;
    actionType: VendorAuditActionType;
}

export interface VendorRequest {
    id: number;
    vendor?: string | undefined;
    vendorId: number;
    vendorRequestId?: string | undefined;
    companyName?: string | undefined;
    contactName?: string | undefined;
    location?: string | undefined;
    contactEmail?: string | undefined;
    job?: string | undefined;
    vendorUserId?: string | undefined;
    vendorCompanyId?: string | undefined;
    salesContact?: string | undefined;
    salesContactGuid?: string | undefined;
    isFirmwideRequest: boolean;
    sourceUrl?: string | undefined;
    requestOrigin?: InsightRequestAccessOrigin | undefined;
    comment?: string | undefined;
    step: ValidationSteps;
    requestedOn?: Date | undefined;
    lastNotifiedOn?: Date | undefined;
    nextAvailableSteps?: ValidationSteps[] | undefined;
    insightProfiles?: InsightProfile[] | undefined;
    isRequestedBySalesOnBehalf: boolean;
    invalidReason?: string | undefined;
    audits?: VendorAuditEntry[] | undefined;
}

export interface VendorRequestBody {
    id?: number | undefined;
    salesContactId?: string | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    steps?: ValidationSteps[] | undefined;
    vendorIds?: number[] | undefined;
    contactEmail?: string | undefined;
    skip: number;
    take: number;
}

export interface VendorsUsers {
    id?: string | undefined;
    icId: string;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

export class Utilities
{
    public static async processResponse<T>(
        response: Response,
        isFile: boolean,
        dateFields: string[],
    ): Promise<T> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if (status >= 200 && status < 300) {
            if (isFile) {
                const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
                const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
                return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers } as unknown as T; });
            }
            if (response && response.text) {
                return response.text().then((_responseText) => {
                    try {
                        const result: any = _responseText === '' ? null : JSON.parse(_responseText, (key, value) => {
                            if (value
                                && dateFields?.includes(key)
                                && (typeof value === 'string' || (Array.isArray(value) && value.every(i => typeof i === 'string'))) 
                                ) {
                               if (Array.isArray(value)) {
                                    return value.map(v => Utilities.ConvertToDate(v));
                                }
                                else {
                                    return Utilities.ConvertToDate(value);
                                }
                            }
                            return value;
                        }) as T;
                        return result;
                    } catch (error) {
                        return Promise.reject(new SwaggerException(error instanceof Error ? error.message : 'JSON.parse error', status, _responseText, _headers, null));
                    }
                });
            }
            else {
                return Promise.resolve<T>(<any>null);
            }
        }

        const errorMessage = status < 500 ? 'A server error occurred.' : 'An unexpected server error occurred.';

        if (response instanceof Error) {
        	return Promise.reject(new SwaggerException(response.message, status, response.message, _headers, null));
        }

        if (response && response.text) {
        	const responseText = await response.text();
        	return Promise.reject(new SwaggerException(errorMessage, status, responseText, _headers, null));
        }

        return Promise.resolve<T>(<any>null);
    }

    public static ConvertToDate (value: any) {
        const date = new Date(value);
        return isNaN(date.getTime()) ? value : date;
    }
}